import { makeAutoObservable, runInAction } from 'mobx'
import moment from 'moment/moment'
import { openApi } from '../../../helpers/request'
import { FormEvent } from 'react'
import { message, notification } from 'antd'
import i from '../../../translations/i'
import __select from '../../../helpers/select_entity/__select.controller'
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import { __cpl } from "../../catalog/custom_product_lists/__cpl";
import { isSegmentList, segmentEntries, segmentQuery } from '../../users/users.controller'
import { CartsSegment, cartsFilterParams, cartsFilterQuery, parseCartsSegment } from '../carts/carts.helpers'
import { bonusFormValues } from './PushBonus'

dayjs.extend(utc)
dayjs.extend(timezone)

export interface PushesImageInterface {
    base: string
    uri: string
}

export interface PushesTemplatesInterface {
    id: number
    type: string
    title: string
    description: string
    enabled: boolean
    hour_utc: number
    before_days: number
    image?: any
}

class pushesController {

    templates: PushesTemplatesInterface[] = []

    template: PushesTemplatesInterface = {
        id: 0,
        enabled: true,
        type: 'birthday',
        title: '',
        description: '',
        hour_utc: 0,
        before_days: 0,
        image: null
    }

    push_type = 'instant'

    pushes_types = ['instant', 'delayed']

    oldImage: any = null

    push_create = {
        id: 0,
        title: '',
        description: '',
        devices: 'all',
        postpone_to: dayjs().unix(),
        element_type: '',
        element_id: 0,
        image: null,
        element: null,
        // Баллы получателям: 0 — без начисления
        bonus_amount: 0 as number | null,
        bonus_days: 0 as number | null,
    }

    list = {
        limit: 10,
        offset: 0,
        count: 0,
        list: [],
    }

    loading = false

    // Часовой пояс проекта (kssettings.timezone): время отправки пушей показываем и задаём по нему. Пусто — ещё не загружен
    timezone = ''

    selected_users: any[] = []

    // Рассылка по сегменту из списка клиентов: условия фильтров, адресатов бэкенд подбирает при сохранении
    segment: any = null
    // Рассылка владельцам корзин из списка корзин: его фильтры, адресатов бэкенд подбирает при сохранении
    cartsSegment: CartsSegment | null = null
    // Сколько клиентов в сегменте и до скольких дойдёт пуш (есть приложение, уведомления включены)
    segmentSize: { count: number, reachable: number } | null = null

    constructor() {
        makeAutoObservable(this)
    }

    setSegmentFromUrl(raw: string | null) {
        if (!raw) return

        try {
            this.segment = JSON.parse(raw)
        } catch (error) {
            console.log(error)
            return
        }

        this.selected_users = []
        this.loadSegmentSize()
    }

    loadSegmentSize() {
        this.segmentSize = null

        openApi('get', `/users/segment?${segmentQuery(this.segment)}`, {}, undefined, true)
            .then(result => runInAction(() => this.segmentSize = result.data))
            .catch(error => console.log(error))
    }

    // null — сегмента корзин нет: контроллер общий, прошлый сегмент не должен пережить переход к другому пушу
    setCartsSegmentFromUrl(raw: string | null) {
        this.cartsSegment = parseCartsSegment(raw)
        if (!this.cartsSegment) return

        this.segment = null
        this.selected_users = []
        this.loadCartsSegmentSize()
    }

    loadCartsSegmentSize() {
        this.segmentSize = null
        const filter = cartsFilterQuery(this.cartsSegment?.filters ?? {})

        openApi('get', `/carts/audience${filter ? `?${filter}` : ''}`, {}, undefined, true)
            .then(result => runInAction(() => this.segmentSize = result.data))
            .catch(error => console.log(error))
    }

    // Вернуться к выбору получателей вручную; сегмент убираем и из адреса, чтобы он не вернулся после перезагрузки
    clearSegment() {
        this.segment = null
        this.cartsSegment = null
        this.segmentSize = null

        const params = new URLSearchParams(window.location.search)
        params.delete('segment')
        params.delete('carts')
        const query = params.toString()
        window.history.replaceState(null, '', `${window.location.pathname}${query ? `?${query}` : ''}`)
    }

    preselectUserById(userId: number) {
        if(!userId || userId <= 0) return
        if(this.selected_users.find((el: any) => el.id === userId)) return

        openApi('get', `/users/${userId}`)
            .then(result => {
                this.selected_users = [...this.selected_users, result.data]
            })
            .catch(error => console.log(error.response))
    }

    selectUser(user: any) {
        if(this.selected_users.find((el: any) => el.id === user.id)) {
            this.selected_users = this.selected_users.filter((el: any) => el.id !== user.id)
        } else {
            this.selected_users = [...this.selected_users, user]
        }
    }

    upload(image: any) {
        this.push_create.image = image
        return false
    }

    uploadTemplate(image: any) {
        this.template.image = image
        return false
    }

    getTemplates(type: string = '') {
        openApi('get', `/pushes/templates/${type}`)
            .then(result => {
                console.log(result)
                if(type !== '') this.template = result
                else this.templates = result
            })
            .catch(error => {

            })
    }

    get() {
        this.loading = true

        openApi('get', `/pushes?offset=${this.list.offset}&limit=${this.list.limit}`)
            .then(result => {
                result = result.data
                this.list.list = result.items
                this.list.count = result.count
            })
            .catch(error => console.log(error))
            .finally(() => this.loading = false)
    }

    getOne(id: any) {
        openApi('get', `/pushes/${id}`)
            .then(result => {
                console.log(result)
                this.oldImage = result.data.image
                this.push_create = result.data
                this.push_type = result.data.type
                this.push_create.image = null
                __select.setRefer(result.data.refer)
            })
            .catch(error => console.log(error))
    }

    onChangeType(value: string) {
        // Отложенный по умолчанию уходит в ближайший полный час: время «сейчас» бэкенд отклонит как прошедшее
        this.push_create.postpone_to = value === 'delayed' ? this.nextFullHour() : dayjs().unix()
        this.push_type = value
    }

    // Ближайший полный час по времени проекта (unix). Считаем по смещению пояса: add/startOf у объектов dayjs с поясом
    // при поясе UTC и другом поясе браузера дают сдвинутое время
    nextFullHour(): number {
        const now = dayjs().unix()
        const offset = dayjs.unix(now).tz(this.projectTimezone).utcOffset() * 60

        return (Math.floor((now + offset) / 3600) + 1) * 3600 - offset
    }

    loadTimezone() {
        if (this.timezone) return

        openApi('get', 'settings')
            .then(result => runInAction(() => {
                this.timezone = result.data.timezone || 'UTC'
            }))
            .catch(error => console.log(error))
    }

    // Как и остальные расчёты проекта (TimezoneResolver на бэкенде): без выбранного пояса — UTC
    get projectTimezone(): string {
        return this.timezone || 'UTC'
    }

    // Время проекта как «настенное» время браузера (те же год, месяц, день и час): календарь работает со временем
    // браузера, поэтому ему отдаём и от него принимаем именно такое представление
    wallClock(unix: number) {
        const time = dayjs.unix(unix).tz(this.projectTimezone)

        return dayjs(new Date(time.year(), time.month(), time.date(), time.hour(), 0))
    }

    // Обратно: выбранное в календаре «настенное» время — это время проекта; до часа, как рассылают кроны и сервис
    fromWallClock(value: dayjs.Dayjs): number {
        return dayjs.tz(value.format('YYYY-MM-DD HH:00'), this.projectTimezone).unix()
    }

    isPastDay(current: dayjs.Dayjs): boolean {
        return current.isBefore(this.wallClock(dayjs().unix()).startOf('day'))
    }

    // Для форматирования во времени проекта: moment_custom печатает миллисекунды как UTC, поэтому сдвигаем на пояс проекта
    wallClockMs(unix: number): number {
        return (unix + dayjs.unix(unix).tz(this.projectTimezone).utcOffset() * 60) * 1000
    }

    disabledDate(current: any) {
        return current && current < moment().subtract(1, 'day')
    }

    disabledDateTime = () => ({
        disabledMinutes: () => this.range(0, 60),
        disabledSeconds: () => this.range(0, 60),
    })

    range(start: number, end: number) {
        const result = []
        for (let i = start; i < end; i++) {
            result.push(i)
        }
        return result
    }

    delete(id: number) {
        openApi('delete', `/pushes/${id}`)
            .then(result => {
                console.log(result)
                this.get()
            })
    }

    deletePicture(id: any) {
        openApi('delete', `/pushes/picture/${id}`)
            .then(result => {
                this.oldImage = null
                this.push_create = result
            })
    }

    create(e: FormEvent) {
        e.preventDefault()

        let uri = `/pushes`
        if(this.push_create.id && this.push_create.id > 0) uri += `/${this.push_create.id}`

        const data = new FormData()
        data.append('title', this.push_create.title)
        if(this.push_create.description) data.append('description', this.push_create.description)
        data.append('devices', this.push_create.devices)
        data.append('type', this.push_type)
        data.append('postpone_to', `${this.push_create.postpone_to}`)
        Object.entries(bonusFormValues(this.push_create)).forEach(([key, value]) => data.append(key, value))

        if(__select.select.type !== '') {
            data.append('refer_type', __select.select.type)

            if(__select.select.type === 'custom_product_list'){
                if(__cpl.selectedLists[0] > 0) {
                    data.append('refer_id', __cpl.selectedLists[0])
                } else {
                    // hasError = true
                }
            } else {
                if(__select.select.value || (__select.select.type === 'category' && __select.select.value === '')) {
                    if(__select.select.type === 'url' || __select.select.type === 'url_blank'){
                        data.append('refer_value', __select.select.value)
                    } else {
                        data.append('refer_id', __select.select.value)
                    }
                }
            }
        }

        if(this.push_create.image) {
            // @ts-ignore
            data.append('image', this.push_create.image)
        }

        if (this.segment) {
            segmentEntries(this.segment).forEach(([key, value]) => data.append(`segment[${key}]${isSegmentList(key) ? '[]' : ''}`, value))
        } else if (this.cartsSegment) {
            // Пустой фильтр — это «все корзины с товарами». Без единого поля бэкенд не увидел бы сегмента
            // и разослал пуш всем пользователям, поэтому источник уходит всегда
            data.append('carts_segment[source]', 'carts')
            cartsFilterParams(this.cartsSegment.filters, 'carts_segment').forEach(([key, value]) => data.append(key, value))
        } else if(this.selected_users.length > 0)
            this.selected_users.map((user: any, index: number) => {
                data.append(`users[${index}]`, `${user.id}`)
            })

        openApi('post', uri, data, { key: 'Content-Type', value: 'multipart/form-data' })
            .then(result => {
                window.location.href = '/pushes'
            })
            .catch(error => {
                notification.error({
                    message: i.t('def:errors.error'),
                    description: error.response.data.data.message ?? ''
                })
            })
    }

    saveTemplate(e: FormEvent) {
        e.preventDefault()

        let uri = `/pushes/templates`
        if(this.template.id > 0) uri = `${uri}/${this.template.id}`

        console.log(`${this.template.enabled}`)

        const data = new FormData()
        data.append('title', this.template.title)
        data.append('description', this.template.description)
        data.append('enabled', `${this.template.enabled}`)
        data.append('type', this.template.type)
        data.append('before_days', `${this.template.before_days}`)
        data.append('hour_utc', `${this.template.hour_utc}`)

        // @ts-ignore
        data.append('image', this.template.image)

        openApi('post', uri, data, { key: 'Content-Type', value: 'multipart/form-data' })
            .then(result => {
                console.log(result)
                notification.success({
                    message: i.t('def:success.complete'),
                    description: i.t('def:success.edit'),
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    deleteImageFromTemplate() {
        let uri = `/pushes/templates/image`
        if(this.template.image && this.template.image.id > 0) uri = `${uri}/${this.template.image.id}`

        openApi('delete', uri)
            .then(result => {
                this.template.image = null
                notification.success({
                    message: i.t('def:success.complete'),
                    description: i.t('def:success.edit'),
                })
            })
            .catch(error => {
                console.log(error)
            })
    }
}

export default new pushesController()